import { render, staticRenderFns } from "./child-questions-field.vue?vue&type=template&id=4eb8afc8"
import script from "./child-questions-field.vue?vue&type=script&lang=js"
export * from "./child-questions-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports